import React from 'react';
import { ConfigTitle } from '../../screen-config/views/config-title';
import { VidebisButton } from '../../shared/components/videbis-button/videbis-button';
import '../styles/test-explanation.scss';
import '../styles/text-test.scss';

interface Props {
	onPress: () => void;
	onBack: () => void;
}

export const TextTestExplanation: React.FunctionComponent<Props> = props => {


	return (
		<section className={'limit-width'}>
			<ConfigTitle title={'Sehtest 4: Vergrößerungsbedarf'} subtitle={'Welcher Text ist für Sie gut lesbar?'} />
			<p className={'text-test__description standard-text'}>
				Bitte wählen Sie im nächsten Schritt <strong>den kleinsten noch lesbaren Text</strong> aus. Achten Sie dabei darauf,
				dass Sie den Text <strong>möglichst flüssig lesen</strong> können. Zusätzlich können Sie verschiedene <strong>Farbkontraste </strong>
				und <strong>Schriftarten </strong> erproben.
			</p>
			<div className={'test-explanation__buttons'}>
				<VidebisButton
					onPress={props.onBack}
					text={'Zurück'}
					bgColor={'#ffffff'}
					txtColor={'#0c23fb'} />
				<div className={'test-explanation__start-button'} onClick={props.onPress}>
					<VidebisButton onPress={props.onPress} text={'Starten!'} />
				</div>
			</div>
		</section>
	);
};
